import { GridReportService } from "@/_services/api/reports/grid-report.service";
import { CacheService } from "../_services/cache/cache-service";

export const defaultDateSettings = {
  namespaced: true,
  state: {
    dateSettings: {
      currentFiscalYear: undefined,
      currentFiscalMonth: undefined,
      thisFiscalPeriod: undefined
    },
  },
  actions: {
    async setCurrentFiscalData({ commit }) {
      var dateSetting = CacheService.getCache('ReportFiscalPeriod');

      if (!dateSetting) {
        return await GridReportService.requestData({
          url: "api/ReportFiscalPeriod",
          filter: "IsCurrentFiscalPeriod eq true",
        })
          .then((result) => {

            if (result.data.value.length > 0) {
              commit("setCurrentFiscalYear", result.data.value[0].FiscalYear);
              commit("setCurrentFiscalMonth", result.data.value[0].YearMonthId);
              commit("setThisFiscalPeriod", result.data.value[0].ThisFiscalPeriod);

              CacheService.saveCache('ReportFiscalPeriod', result.data.value[0], 1, 'day');
            }
          });
      }
      else {
        commit("setCurrentFiscalYear", dateSetting.FiscalYear);
        commit("setCurrentFiscalMonth", dateSetting.YearMonthId);
        commit("setThisFiscalPeriod", dateSetting.ThisFiscalPeriod);
      }
    },
  },
  mutations: {
    setCurrentFiscalYear(state, fiscalYear) {
      state.dateSettings.currentFiscalYear = fiscalYear;
    },
    setCurrentFiscalMonth(state, fiscalMonth) {
      state.dateSettings.currentFiscalMonth = fiscalMonth;
    },
    setThisFiscalPeriod(state, fiscalPeriod) {
      state.dateSettings.thisFiscalPeriod = fiscalPeriod;
    },
  },
  getters: {
    getDateSettings: (state) => () => {
      return state.dateSettings;
    },
  },
};
